var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"m-theme-warning-message-wrapper"},[_c('div',{staticClass:"m-theme-warning-message"},[_c('img',{staticClass:"warning-icon",attrs:{"src":require("./images/warning-icon.png")}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.props.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }